// extracted by mini-css-extract-plugin
module.exports = {"root":"FileInfo_root__3hP04","filename":"FileInfo_filename__24CdR","size":"FileInfo_size__3u2hS","button":"FileInfo_button__Kqsb6"};